import React from 'react';
import { makeStyles } from '@mui/styles';

export enum ControlButtonColor {
    BLUE = 'blue',
    ORANGE = 'orange',
}

const useStyles = makeStyles(() => ({
    button: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px',
        borderRadius: 8,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        border: '1px solid',
        boxShadow: '0px 8px 16px 4px #00000010',
        transition: 'all 0.2s ease',
        '&:hover': {
            transform: 'translateY(-1px)'
        },
        // Tablet and mobile styles
        '@media (max-width: 1024px)': {
            padding: '12px',
            gap: 0,
            justifyContent: 'center'
        }
    },
    blueButton: {
        background: '#F7F9FD',
        borderColor: '#5E83E1',
        '& $icon': {
            color: '#5E83E1'
        },
        '&:hover': {
            borderColor: '#5E83E150'
        },
        color: '#5E83E1'
    },
    orangeButton: {
        background: '#FDF9F7',
        borderColor: '#E1955E',
        '& $icon': {
            color: '#E1955E'
        },
        '&:hover': {
            borderColor: '#E1955E50'
        },
        color: '#E1955E'
    },
    icon: {
        fontSize: 20,
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        // Hide content on tablet and mobile
        '@media (max-width: 1024px)': {
            display: 'none'
        }
    },
    title: {
        fontFamily: 'Manrope',
        fontWeight: 600,
        fontSize: 16,
    },
    subtitle: {
        fontFamily: 'Manrope',
        fontWeight: 300,
        fontSize: 14,
    }
}));

interface ControlButtonProps {
    icon: string;
    title: string;
    subtitle: string;
    color: ControlButtonColor;
    onClick?: () => void;
}

const ControlButton: React.FC<ControlButtonProps> = ({
    icon,
    title,
    subtitle,
    color,
    onClick
}) => {
    const classes = useStyles();

    const getColorClass = () => {
        switch (color) {
            case ControlButtonColor.BLUE:
                return classes.blueButton;
            case ControlButtonColor.ORANGE:
                return classes.orangeButton;
            default:
                return classes.blueButton;
        }
    };

    return (
        <button 
            className={`${classes.button} ${getColorClass()}`}
            onClick={onClick}
        >
            <i className={`fas fa-${icon} ${classes.icon}`} />
            <div className={classes.content}>
                <div className={classes.title}>{title}</div>
                <div className={classes.subtitle}>{subtitle}</div>
            </div>
        </button>
    );
};

export default ControlButton;
